module.exports = __webpack_public_path__ + "img/our_service.229b864d.png";